/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import {
  Box, Divider, Grid, InputAdornment,
} from '@mui/material';
import './_accountSetting.scss';
import { useDispatch } from 'react-redux';
import type { SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import axios from 'axios';
import HookTextField from 'shared-components/hooks/HookTextField';
import PrimayButton from 'shared-components/components/PrimayButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { setLogin } from 'client/login/store';
import type { Iuser } from 'types';
import type { IFormValues } from 'formsTypes';
import type { IUpdateEmailForm } from '../AdminFormTypes';

interface Iprops {
  user: Iuser;

}
interface IErrData {
  message: string;
}
interface IError {
  data: IErrData;
}
interface Iendorment {
  show: boolean;
  setShow: (value: boolean) => void;
}
function EndAdornment(props: Iendorment): JSX.Element {
  const { show, setShow } = props;
  return (
    <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
      { show ? <VisibilityIcon onClick={(): void => { setShow(false); }} /> : <VisibilityOffIcon onClick={(): void => { setShow(true); }} />}

    </InputAdornment>
  );
}
export default function EmailUpdate(props: Iprops): JSX.Element {
  const dispatch = useDispatch();
  const { user } = props;
  const [editEmail, showEditEmail] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const emailDefaultValues: IUpdateEmailForm = {
    email: '',
    current_password: '',
  };

  const { enqueueSnackbar } = useSnackbar();

  const schema = yup.object().shape({
    email: yup.string().required('Email is required').email('Please enter valid email'),
    current_password: yup.string().required('Please enter current password'),
  });

  const {
    control, formState, handleSubmit, reset,
  } = useForm<IFormValues>({
    mode: 'onChange',
    defaultValues: emailDefaultValues,
    resolver: yupResolver(schema),
  });

  const { errors } = formState;

  const {
    mutate,
  } = useMutation(async (data: IUpdateEmailForm) => axios({
    url: 'api/users/change-email/',
    method: 'POST',
    data,
  }), {
    onSuccess: (data) => {
      reset(emailDefaultValues);
      enqueueSnackbar('Email Updated Successfully!');
      dispatch(setLogin({ ...user, ...data.data }));
    },
    onError: (err: IError) => {
      enqueueSnackbar(err.data.message, {
        variant: 'error',
        content: (key, message) => (
          <div className='text-white bg-danger ps-4 pe-5 py-3'>
            {message}
          </div>
        ),
      });
    },
  });

  const onSubmit: SubmitHandler<IUpdateEmailForm> = (data: IUpdateEmailForm) => {
    mutate(data);
  };

  return (
    <Box mt={3} className='accordian-container'>

      <Typography className='accordian-desc'>
        Email Address
      </Typography>
      <Grid className='accordian-header'>
        <Grid item lg={6} className='header-1'>
          {' '}
          <Typography className='accordian-desc-1'>
            Your email address is
            {' '}
            {user.email}
          </Typography>
        </Grid>
        <Grid item lg={6} className='header-2'>
          <Typography className='accordian-desc-2' onClick={(): void => { showEditEmail((pre) => !pre); }}>
            {editEmail ? 'Hide' : 'Change'}
            {' '}
          </Typography>
        </Grid>
      </Grid>

      {editEmail && (
        <Box mb={2}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid mt={1} className='update-name'>
              {' '}
              <Grid item className='hook-field-1'>
                {' '}
                <HookTextField
                  name='email'
                  label='New Email Address'
                  control={control}
                  errors={errors}
                  maxLength={150}
                />

              </Grid>
              <Grid item className='hook-field-2'>
                <HookTextField
                  type={showConfirmPass ? 'text' : 'password'}
                  name='current_password'
                  label='Current Password'
                  control={control}
                  errors={errors}
                  maxLength={150}
                  endAdornment={<EndAdornment show={showConfirmPass} setShow={setShowConfirmPass} />}
                />

              </Grid>
            </Grid>

            <Box sx={{ width: '126px', height: '33px' }}><PrimayButton type='submit'> Update Email</PrimayButton></Box>

          </form>

        </Box>
      )}
      <Divider sx={{ marginTop: '2.5rem' }} />
    </Box>

  );
}
